import socketio from "socket.io-client";
import React from "react";
import { host } from "./Config";

const socket = socketio.connect(host, {
  autoConnect: false,
  transports: ["websocket"],
});

export const SocketContext = React.createContext();

export const authenticateSocket = (token, number) => {
  // console.log("inside, authenticateSocket");
  // console.log(token, number );
  socket.auth = { token, clientId: `${number}` };
  socket.connect();
  return true;
};

socket.on("joinRoomResponse", (data) => {
  // console.log()
});

export default socket;
